export const waLink = (number, text) =>
  `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const bookingChatText = (bookingId) =>
  `Hi CelebrAI! I'd like to confirm my booking ${bookingId} — availability, my requirements and the final price.`;
